module.exports = __webpack_public_path__ + "static/img/pexels-photo-106399.2d0d569b.jpeg";